//Created by wangshuyi on 2021/6/27.

'use strict';

let dotNetUtil = {};

const FILTER_MAP = [
    {
        match: /_number$/,
        formatter: (key, value, condition) => ({
            "FILTER_FIELD": key.replace(/_number$/, ''),
            "FILTER_TYPE": "2",
            "FILTER_VALUE1": value.toString(),
            "FILTER_VALUE2": ""
        })
    },
    {
        match: /_date_start$/,
        formatter: (key, value, condition) => {
            let realKey = key.replace(/_date_start$/, '');
            let hasCondition = condition.find(c => c['FILTER_FIELD'] === realKey);
            if (hasCondition) {
                hasCondition["FILTER_VALUE1"] = value.toString();
            } else {
                return {
                    "FILTER_FIELD": realKey,
                    "FILTER_TYPE": "3",
                    "FILTER_VALUE1": value.toString(),
                    "FILTER_VALUE2": ""
                }
            }
        }
    },
    {
        match: /_date_end$/,
        formatter: (key, value, condition) => {
            let realKey = key.replace(/_date_end$/, '');
            let hasCondition = condition.find(c => c['FILTER_FIELD'] === realKey);
            if (hasCondition) {
                hasCondition["FILTER_VALUE2"] = value.toString();
            } else {
                return {
                    "FILTER_FIELD": realKey,
                    "FILTER_TYPE": "3",
                    "FILTER_VALUE1": "",
                    "FILTER_VALUE2": value.toString()
                }
            }
        }
    },
    {
        match: /_like$/,
        formatter: (key, value, condition) => ({
            "FILTER_FIELD": key.replace(/_like$/, ''),
            "FILTER_TYPE": "4",
            "FILTER_VALUE1": value.toString(),
            "FILTER_VALUE2": ""
        })
    },
    {
        match: /string_multiple$/,
        formatter: (key, value, condition) => {
            return value.length > 0 ? {
                "FILTER_FIELD": key.replace(/string_multiple$/, ''),
                "FILTER_TYPE": "5",
                "FILTER_VALUE1": value ? value.join("#") : "",
                "FILTER_VALUE2": ""
            } : null;
        }
    },
    {
        match: /_number_multiple$/,
        formatter: (key, value, condition) => {
            return value.length > 0 ? {
                "FILTER_FIELD": key.replace(/_number_multiple$/, ''),
                "FILTER_TYPE": "6",
                "FILTER_VALUE1": value ? value.join("#") : "",
                "FILTER_VALUE2": ""
            } : null;
        }
    },
    {
        match: /_permission$/,
        formatter: (key, value, condition) => ({
            "FILTER_FIELD": key.replace(/_permission$/, ''),
            "FILTER_TYPE": "101",
            "FILTER_VALUE1": value.toString(),
            "FILTER_VALUE2": ""
        })
    },
];

/**
 * 格式化查询条件
 * @param queryForm
 * @returns {[]}
 */
dotNetUtil.filterFormat = (queryForm) => {
    let condition = [];
    Object.keys(queryForm).forEach(key => {
        if (queryForm[key] === "" || queryForm[key] === undefined) {
            return true; //没有填写的字符串直接跳过
        }

        let defaultFlag = true;
        FILTER_MAP.some(filter => {
            if (filter.match.test(key)) {
                defaultFlag = false;
                let formatCondition = filter.formatter(key, queryForm[key], condition);
                if (formatCondition) {
                    condition.push(formatCondition);
                }
                return true;
            }
        });
        if (defaultFlag) {
            condition.push({
                "FILTER_FIELD": key,
                "FILTER_TYPE": "1",
                "FILTER_VALUE1": queryForm[key].toString(),
                "FILTER_VALUE2": ""
            });
        }
    });

    return condition;
}

dotNetUtil.commonQueryJson = (tableName, condition, getMethod = 1, sortField) => {
    let object = {
        "GET_HEAD": [{"GET_METHOD": getMethod, "GET_TABLE": tableName}],
        "GET_FILTER": condition ? dotNetUtil.filterFormat(condition) : [],
    }
    if (sortField) {
        object['GET_HEAD'][0]["SORT_FIELD"] = sortField;
    }
    return {jsonParam: JSON.stringify(object)}
}
dotNetUtil.commonPageJson = (tableName, condition, pageNumber, pageSize, sortField, getMethod = 1) => {
    return {
        jsonParam: JSON.stringify({
            "GET_HEAD": [{
                "GET_METHOD": getMethod,
                "GET_TABLE": tableName,
                "BEGIN_ROW_NO": pageNumber,
                "GET_ROW_CNT": pageSize,
                "SORT_FIELD": sortField
            }],
            "GET_FILTER": condition ? dotNetUtil.filterFormat(condition) : [],
        })
    }
}
dotNetUtil.commonReportJson = (tableName, condition, pageNumber, pageSize, sortField, getMethod = 1) => {
    return {
        jsonParam: JSON.stringify({
            "GET_HEAD": [{
                "GET_METHOD": getMethod,
                "BEGIN_ROW_NO": pageNumber,
                "GET_ROW_CNT": pageSize,
                ...tableName
            }],
            "GET_FILTER": condition ? dotNetUtil.filterFormat(condition) : [],
        })
    }
}
dotNetUtil.commonExportJson = (tableName, condition, sortField, getMethod = 3) => {
    return {
        jsonParam: JSON.stringify({
            "GET_HEAD": [{
                "GET_METHOD": getMethod,
                ...tableName
            }],
            "GET_FILTER": condition ? dotNetUtil.filterFormat(condition) : [],
        })
    }
}

/**
 *
 * @param tableName
 * @param primaryKey
 * @param editFlag
 * @param data
 * UPDATE_BY, 临时先用10000001，登录功能完成以后，换为当前登录人【this.$store && this.$store.state.token】
 * @returns {{jsonParam: string}}
 */
dotNetUtil.commonSaveJson = (tableName, primaryKey, editFlag, data) => {
    return {
        jsonParam: JSON.stringify({
            "POST_HEAD": [{
                "TABLE_NAME": tableName,
                "POST_METHOD": editFlag ? 2 : 1,
                "PRIMARY_KEY": primaryKey,
                "UPDATE_BY": $DolAntPage && $DolAntPage.$store && $DolAntPage.$store.state.token,
            }],
            "POST_CONTEXT": data,
        })
    }
}
dotNetUtil.commonDeleteJson = (tableName, primaryKey, data) => {
    return {
        jsonParam: JSON.stringify({
            "POST_HEAD": [{
                "TABLE_NAME": tableName,
                "POST_METHOD": 3,
                "PRIMARY_KEY": primaryKey,
                "UPDATE_BY": $DolAntPage && $DolAntPage.$store && $DolAntPage.$store.state.token,
            }],
            "POST_CONTEXT": data,
        })
    }
}

dotNetUtil.getOrgRefSql = (tableName) => {
    return dotNetUtil.getRefSql(tableName, [
        {tableName: 'GM_ORG', showFields: ['ORG_NAME'], refField: 'ORG_ID'}
    ]);
}
dotNetUtil.getRefSql = (primaryTable, refInfoList = []) => {
    let select = `${primaryTable}.*`;
    let from = `${primaryTable}`;
    let where = ``;
    refInfoList.forEach((refInfo, i) => {
        if (i !== 0) {
            where += ' and ';
        }
        refInfo.showFields.forEach(field => select += `,${refInfo.tableName}.${field}`);
        from += `,${refInfo.tableName}`;
        where += `${refInfo.refTable || primaryTable}.${refInfo.refTableField || refInfo.refField}=${refInfo.tableName}.${refInfo.refField}`
    });

    let sql = `select ${select} from ${from}`;
    if (where) {
        sql += ` where ${where}`
    }

    return sql;
}

export default dotNetUtil;
